export default {
    showMessage: function (messageValue) {
        alert(messageValue);
    },
    showToast: function (type, title, msg) {
        toastr.options = {
            closeButton: false,
            debug: false,
            positionClass: 'toast-top-right',
            onclick: null,
            showDuration: 1000,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000,
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut',
            tapToDismiss : true
        };

        let $toast = toastr[type](msg, title); // Wire up an event handler to a button in the toast, if it exists
    },
    showActionToast: function (type, title, msg, fun) {
        toastr.options = {
            closeButton: true,
            debug: false,
            positionClass: 'toast-top-full-width',
            showDuration: 1000,
            hideDuration: 1000,
            timeOut: 600000,
            extendedTimeOut: 600000,
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut',
            tapToDismiss : false,
            onclick: fun
        };

        let $toast = toastr[type](msg, title); // Wire up an event handler to a button in the toast, if it exists
    },
    reloadPage: function () {
        window.location.reload();
    },
    goToUrl: function (url) {
        window.location = url;
    },
    goToUrlBlank: function (url) {
        window.open(url, '_blank');
    },
    getMonthName: function (monthIndex) {
        let monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        return monthNames[monthIndex];
    },
    formatMilliseconds: function (s) {
        let ms = s % 1000;
        s = (s - ms) / 1000;
        let secs = s % 60;
        s = (s - secs) / 60;
        let mins = s % 60;
        let hrs = (s - mins) / 60;

        let sHrs = hrs.toString();
        if (sHrs.length < 2) {
            sHrs = '0' + sHrs;
        }
        let sMins = mins.toString();
        if (sMins.length < 2) {
            sMins = '0' + sMins;
        }
        let sSecs = secs.toString();
        if (sSecs.length < 2) {
            sSecs = '0' + sSecs;
        }

        return sHrs + ':' + sMins + ':' + sSecs;
    },

    getCurrentDate() {
        return new Date().toISOString();
    },

    formatDate(str) {
        let d = new Date(str);
        return d.getDate() + ' ' + this.getMonthNameRUS(d.getMonth()) + ' ' + d.getFullYear();
    },

    getTime(str) {
        let d = new Date(str);
        let hours = d.getHours();
        let minutes = d.getMinutes();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        return hours + ':' + minutes;
    },

    getMonthNameRUS: function (monthIndex) {
        /*
        let monthNames = ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня",
            "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"
        ];*/

        let monthNames = ["января", "февраля", "марта", "апреля", "мая", "июня",
            "июля", "августа", "сентября", "октября", "ноября", "декабря"
        ];

        return monthNames[monthIndex];
    },

    getPaginationIndexes: function(totalPages /* всего страниц */, displayedPagesCount /* число отображаемых страниц, нечетное число */, currentPageIndex /* индекс текущей страницы*/) {
        let indexes = [];

        let indexesLeft = displayedPagesCount-1;
        let start = currentPageIndex - indexesLeft/2 > 0 ? currentPageIndex - indexesLeft/2 : 1;
        if (currentPageIndex + indexesLeft/2 > totalPages) start -= currentPageIndex + indexesLeft/2 - totalPages;
        if (start <= 0) start = 1;

        for (let pageIndex = start, total=0; total < displayedPagesCount && pageIndex <= totalPages; total++, pageIndex++) {
            indexes.push(pageIndex);
        }
        return indexes;
    }
};


// WEBPACK FOOTER //
// ./src/common.js